/// <reference path="../ts-declarations/assets.d.ts" />
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
0 && __export(require("./native")) && __export(require("./elements"));
_export_star(require("./native"), exports);
_export_star(require("./elements"), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}

//# sourceMappingURL=index.js.map
